import { render, staticRenderFns } from "./pageLost.vue?vue&type=template&id=3187f551&scoped=true&"
import script from "./pageLost.js?vue&type=script&lang=js&"
export * from "./pageLost.js?vue&type=script&lang=js&"
import style0 from "./pageLost.vue?vue&type=style&index=0&id=3187f551&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3187f551",
  null
  
)

export default component.exports